<template>
  <div>
    <div class="row justify-between bdr-t-grey-4 q-py-md">
      <span class="text-weight-bold">ITEMS</span>
      <span class="text-weight-bold">REMAINING BUDGET</span>
    </div>
    <div
      v-for="(row, index) in items"
      :key="index"
      class="q-py-lg bdr-t-grey-4 cursor-pointer"
      @click="$emit('open:budget', row)"
    >
      <BudgetProgress
        :budget="row"
        :icon="row.icon"
        :label="row.label"
        class="col"
        display-forward-arrow
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BudgetTable',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BudgetProgress: () => import('../budget-progress')
  }
};
</script>
